<template>
  <b-row>
    <b-col v-for="(media, i) in mediaList" v-show="isMediaVisible(media)" :key="i" cols="6" md="4" xl="3" class="mb-3">
      <b-row>
        <b-col>
          <MediaCard
            v-if="selectMode"
            :media="media"
            :show-select-box="true"
            :can-delete-media="false"
            :show-delete-media="showDeleteMedia"
            :aria-label="media.title"
            :is-new="getMediaIsNew(media)"
            tabindex="0"
            role="checkbox"
            :aria-checked="media.selected"
            @onDeleteMediaClick="onDeleteMediaClick(media)"
            @click="onMediaSelected(media)"
          />
          <MediaCard
            v-else
            v-button
            :media="media"
            :can-delete-media="
              canDeleteMedia ||
              media.currentUserCanDelete ||
              institutions.some(inst => inst.institutionProfileId == media.creator.id).length > 0
            "
            :is-new="getMediaIsNew(media)"
            :show-delete-media="showDeleteMedia"
            @onDeleteMediaClick="onDeleteMediaClick(media)"
            @click="onOpenMedia(media)"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import MediaCard from './MediaCard.vue';
import { mapGetters } from 'vuex';
import { types } from '../../../src/store/types/types';
import Button from '../../directives/button';
import { notificationEventTypes } from '../../enums/notificationEventTypes';
import { ScanningStatusEnum } from '../../enums/scanningStatus.enum';
import { useUserProfileStore } from '../../stores';

export default {
  name: 'MediaList',
  directives: {
    Button,
  },
  components: { MediaCard },
  props: {
    mediaList: { type: Array, default: () => [] },
    selectMode: { type: Boolean, default: false },
    canDeleteMedia: { type: Boolean, default: false },
    showDeleteMedia: { type: Boolean, default: true },
    relatedNotifications: { type: Array, default: () => [] },
  },
  computed: {
    ...mapGetters({
      institutions: types.GET_INSTITUTIONS,
    }),
    userProfile() {
      return useUserProfileStore().institutionProfile;
    },
  },
  methods: {
    isMediaVisible(media) {
      return (
        media.file?.scanningStatus !== ScanningStatusEnum.BLOCKED ||
        media.creator?.profileId === this.userProfile.profileId
      );
    },
    getMediaIsNew(media) {
      return this.relatedNotifications.some(notification => {
        const isTaggedInMedia = notification.notificationEventType === notificationEventTypes.TAGGED_IN_MEDIA;
        const mediaId = isTaggedInMedia
          ? parseInt(notification.notificationId.split(':')[1].split('-')[1])
          : notification.mediaId;
        return mediaId === media.id;
      });
    },
    onMediaSelected(media) {
      this.$emit('onMediaSelected', media);
    },
    onDeleteMediaClick(media) {
      this.$emit('onDeleteMediaClick', media);
    },
    onOpenMedia(media) {
      this.$emit('onOpenMedia', media);
    },
  },
};
</script>
